import React from 'react';
import PropTypes from 'prop-types';
import { Router, Route } from 'react-router';

import SafeTradeBuyerConversation from './safeTradeBuyerConversation.jsx';
import SafeTradeBuyerStatus from './safeTradeBuyerStatus.jsx';
import SafeTradeOnboarding from '../onboarding/onboarding.jsx';
import {
    hasSeenOnboarding,
    setSeenOnboarding,
} from '../onboarding/onboardingService';

import EnterAmount from './agreement/enterAmount.jsx';
import AgreementSentDetails from './agreement/statusDetails/agreementSentDetails.jsx';
import AgreementAcceptedDetails from './payment/statusDetails/agreementAcceptedDetails.jsx';
import HandleItemPage from './agreement/handleItemPage.jsx';
import HandleTransferPaymentDetails from './payment/statusDetails/handleTransferPaymentDetails.jsx';
import ItemApprovedDetails from './payment/statusDetails/itemApprovedDetails.jsx';
import PaymentRevertedDetails from './payment/statusDetails/paymentRevertedDetails.jsx';
import PaymentCompletedDetails from './payment/statusDetails/paymentCompletedDetails.jsx';
import PaymentCanceledDetails from './payment/statusDetails/paymentCanceledDetails.jsx';

import DiscountSuggestedDetails from './resolution/statusDetails/discountSuggestedDetails.jsx';
import DiscountApprovedDetails from './resolution/statusDetails/discountApprovedDetails.jsx';

import HandleMissingItemPage from './resolution/handleMissingItemPage.jsx';
import HandleDefectItemPage from './resolution/handleDefectItemPage.jsx';
import SuggestDiscountPage from './resolution/suggestDiscountPage.jsx';

import CreateAgreementError from './agreement/createAgreementError.jsx';
import PaymentError from './payment/paymentError.jsx';
import ApproveItemError from './payment/approveItemError.jsx';

import DelayPaymentError from './resolution/delayPaymentError.jsx';
import ApproveDiscountError from '../resolution/approveDiscountError.jsx';
import SuggestDiscountError from '../resolution/suggestDiscountError.jsx';

const App = ({ children }) => <div>{children}</div>;

const SafeTradeAsBuyer = ({
    onEnter,
    onOpenFullScreen,
    onCloseFullScreen,
    history,
}) => (
    <Router history={history}>
        <Route path="/" component={App} onEnter={onEnter}>
            <Route
                path="/samtale"
                component={SafeTradeBuyerConversation}
                onEnter={onCloseFullScreen}
            />
            {/* TODO: Use `replace` argument to onEnter, this is a hack */}
            <Route
                path="/status"
                component={SafeTradeBuyerStatus}
                onEnter={onOpenFullScreen}
            />
            <Route
                path="/hva-er-trygg-betaling"
                component={SafeTradeOnboarding}
                onEnter={() => {
                    setSeenOnboarding();
                    onOpenFullScreen();
                }}
            />
            <Route
                path="/start-trygg-betaling"
                component={EnterAmount}
                onEnter={(_, replace) => {
                    if (hasSeenOnboarding()) {
                        onOpenFullScreen({ keepHeader: true });
                    } else {
                        replace('/hva-er-trygg-betaling');
                    }
                }}
            />
            <Route
                path="/avtale-feilet"
                component={CreateAgreementError}
                onEnter={onOpenFullScreen}
            />
            <Route
                path="/avtale-sendt"
                component={AgreementSentDetails}
                onEnter={onOpenFullScreen}
            />
            <Route
                path="/avtale-godkjent"
                component={AgreementAcceptedDetails}
                onEnter={onOpenFullScreen}
            />
            <Route
                path="/betaling-ferdig*"
                component={PaymentCompletedDetails}
                onEnter={onOpenFullScreen}
            />
            <Route
                path="/betaling-avbrutt"
                component={PaymentCanceledDetails}
                onEnter={onOpenFullScreen}
            />
            <Route
                path="/betaling-feilet(/:code)"
                component={PaymentError}
                onEnter={onOpenFullScreen}
            />
            <Route
                path="/godkjenn-eller-avsla-vare"
                component={HandleItemPage}
                onEnter={onOpenFullScreen}
            />
            <Route
                path="/godkjenn-vare-feilet"
                component={ApproveItemError}
                onEnter={onOpenFullScreen}
            />
            <Route
                path="/godkjenn-utbetaling"
                component={HandleTransferPaymentDetails}
                onEnter={onOpenFullScreen}
            />
            <Route
                path="/losning/noe-er-galt-med-varen"
                component={HandleDefectItemPage}
                onEnter={onOpenFullScreen}
            />
            <Route
                path="/losning/manglende-vare"
                component={HandleMissingItemPage}
                onEnter={onOpenFullScreen}
            />
            <Route
                path="/losning/godta-avslag-feilet"
                component={ApproveDiscountError}
                onEnter={onOpenFullScreen}
            />
            <Route
                path="/losning/foresla-avslag"
                component={SuggestDiscountPage}
                onEnter={onOpenFullScreen}
            />
            <Route
                path="/losning/foresla-avslag-feilet"
                component={SuggestDiscountError}
                onEnter={onOpenFullScreen}
            />
            <Route
                path="/losning/avslag-foreslatt"
                component={DiscountSuggestedDetails}
                onEnter={onOpenFullScreen}
            />
            <Route
                path="/losning/enighet-om-avslag"
                component={DiscountApprovedDetails}
                onEnter={onOpenFullScreen}
            />
            <Route
                path="/losning/utsett-betaling-feilet"
                component={DelayPaymentError}
                onEnter={onOpenFullScreen}
            />
            <Route
                path="/varen-er-godkjent"
                component={ItemApprovedDetails}
                onEnter={onOpenFullScreen}
            />
            <Route
                path="/handel-hevet"
                component={PaymentRevertedDetails}
                onEnter={onOpenFullScreen}
            />
        </Route>
    </Router>
);

SafeTradeAsBuyer.propTypes = {
    onEnter: PropTypes.func.isRequired,
    onOpenFullScreen: PropTypes.func.isRequired,
    onCloseFullScreen: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
};

export default SafeTradeAsBuyer;



// WEBPACK FOOTER //
// ./safeTrade/buyer/safeTradeAsBuyer.jsx